var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7.457,
    viewBox: "0 0 10 7.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M3.4,11.888.146,8.638a.5.5,0,0,1,0-.707l.707-.707a.5.5,0,0,1,.707,0L3.75,9.413,8.439,4.724a.5.5,0,0,1,.707,0l.707.707a.5.5,0,0,1,0,.707L4.1,11.888A.5.5,0,0,1,3.4,11.888Z",
    transform: "translate(0 -4.577)",
    fill: "#3ec868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.3de43df0ad2fe53ec854cd10bbc350f4.svg";
export { ForwardRef as ReactComponent };